import { withFormik } from 'formik';
import schema from './schema';
import EnquireForm from './EnquireForm';

export default withFormik({
  mapPropsToValues: props => ({
    firstName: props.form.firstName,
    lastName: props.form.lastName,
    email: props.form.email,
    phone: props.form.phone,
    address: props.form.address,
    message: props.form.message,
  }),
  validationSchema: schema,
  handleSubmit: (values, { props, setErrors, setSubmitting, resetForm }) => {
    props.onSubmit(values, { setErrors, setSubmitting, resetForm });
  },
})(EnquireForm);



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/parts/EnquireForm/index.js